__turbopack_context__.v({
  "active": "styles-module__AbfdnG__active",
  "checkIcon": "styles-module__AbfdnG__checkIcon",
  "chevronIcon": "styles-module__AbfdnG__chevronIcon",
  "dropdown": "styles-module__AbfdnG__dropdown",
  "head": "styles-module__AbfdnG__head",
  "list": "styles-module__AbfdnG__list",
  "markerIcon": "styles-module__AbfdnG__markerIcon",
  "option": "styles-module__AbfdnG__option",
  "optionActive": "styles-module__AbfdnG__optionActive",
});
